(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-floating-whatsapp]');
    if (!root) return;

    var toggle = root.querySelector('[data-floating-whatsapp-toggle]');
    var popup = root.querySelector('#FloatingWhatsappPopup');
    var cta = root.querySelector('[data-wa-cta]');
    if (!toggle || !popup || !cta) return;

    var waNumber = root.dataset.waNumber;
    var productName = root.dataset.waProduct || '';
    var defaultMessage = root.dataset.waDefaultMessage || 'Hi, I have a question\u2014can you assist me?';

    var message = productName
      ? 'Hi, I\'m interested in ' + productName + '. Can you help me?'
      : defaultMessage;

    cta.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(message);

    function setOpen(isOpen) {
      popup.style.display = '';
      root.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      popup.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }

    toggle.addEventListener('click', function () {
      setOpen(!root.classList.contains('is-open'));
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target) && root.classList.contains('is-open')) {
        setOpen(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        setOpen(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
